import * as React from 'react'
import Skeleton from '@mui/material/Skeleton'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'

function MapBubbleContentsSkeleton() {
  return (
    <>
      {/* Name and company display with close button */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Skeleton variant="text" width={200} height={32} />
      </Stack>

      {/* Address display */}
      <Skeleton variant="text" width={180} height={20} />

      {/* Phone and location link */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Skeleton variant="text" width={140} height={20} />
        <Skeleton variant="text" width={100} height={20} />
      </Stack>

      {/* Paper section with entity type, status, and knock status */}
      <Paper
        variant="outlined"
        sx={{
          mt: 0.8,
          px: 1.2,
          pt: 1.2,
          pb: 1.6,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Entity type display */}
        <Skeleton variant="text" width={120} height={24} sx={{ mb: 0.8 }} />
        {/* Status */}
        <Skeleton variant="text" width={100} height={20} />
        {/* Knock status */}
        <Skeleton variant="text" width={120} height={20} sx={{ mt: 0.8 }} />
      </Paper>

      {/* Action buttons section */}
      <Box mt={1.6}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            gap: 0.8,
          }}
        >
          <Skeleton
            variant="rectangular"
            width="100%"
            height={36}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={36}
            sx={{ borderRadius: 1 }}
          />
        </Box>
      </Box>
    </>
  )
}

export default MapBubbleContentsSkeleton
